import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function TheSystem() {
  const tomos = [{
    num: '1',
    title: 'El Mapa Anual',
    desc: 'Tu año entero deja de ser un misterio. El Tomo 1 te da el mapa completo de los 12 meses. Cada trimestre con su foco. Cada mes con su objetivo. Cada semana con su anclaje. Nunca más llegás al lunes sin saber hacia dónde vas.'
  }, {
    num: '2',
    title: 'La Semana en 20 Minutos',
    desc: 'Tu semana se planifica en 20 minutos. El Tomo 2 te da el método para bajar el plan anual a la realidad del lunes. Las 4 fases del mes. El anclaje semanal que unifica todas tus clases. La hoja de planificación que se completa en menos tiempo del que tardás en el café de antes de entrar.'
  }, {
    num: '3',
    title: 'La Anatomía de la Clase',
    desc: 'Tus clases tienen estructura, ritmo y propósito. El Tomo 3 te da la anatomía exacta de una clase que el alumno recuerda. Calentamientos específicos. Los 4 escalones pedagógicos. Cierres que generan ganas de volver. La diferencia entre una clase que pasa y una clase que queda.'
  }, {
    num: '4',
    title: 'El Sistema de Seguimiento',
    desc: 'Tus alumnos ven su progreso en papel. El Tomo 4 te da el sistema de seguimiento que elimina el abandono silencioso. Fichas individuales. Semáforo de habilidades. Tests de entrada y salida. Informes trimestrales que convierten tu trabajo invisible en evidencia concreta.'
  }, {
    num: '5',
    title: 'El Banco de Ejercicios',
    desc: 'Nunca más te quedás sin ideas en pista. El Tomo 5 te da más de 60 ejercicios organizados por categoría, nivel y objetivo. Variantes para el nivel rojo, amarillo y verde. El banco de recursos que reemplaza la búsqueda del domingo por la consulta de 30 segundos.'
  }, {
    num: '6',
    title: 'La Gestión del Negocio',
    desc: 'Tu negocio deja de funcionar de casualidad. El Tomo 6 te da el sistema de cobros, agenda, métricas y comunicación que convierte tu talento en un negocio ordenado. El tomo que ningún profe tiene pero que todos necesitan para dejar de regalar tiempo y energía.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-padel-dark" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <FadeIn data-id="element-216">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-217">
            <h2 className="text-4xl sm:text-6xl font-display font-black text-white mb-6 uppercase tracking-tight" data-id="element-218">
              EL MÉTODO <span className="text-padel-lime" data-id="element-219">PRO-PÁDEL 360</span>{' '}
              <br data-id="element-220" />
              ES ESE SISTEMA.
            </h2>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-221">
              No es un libro de ejercicios. No es una colección de planillas
              sueltas. No es contenido de Instagram organizado en PDF.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-222">
              Es el sistema completo que transforma la forma en que trabajás
              como profe de pádel. De la planificación anual hasta el cierre de
              cada clase. Del seguimiento individual hasta la gestión del
              negocio. Del diseño de sesiones hasta la comunicación con tus
              alumnos.
            </p>
            <p className="text-xl sm:text-2xl font-bold text-white" data-id="element-223">
              Todo conectado. Todo coherente. Todo listo para usar desde hoy.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-224">
          <h3 className="text-2xl font-display font-bold text-center text-padel-lime mb-10" data-id="element-225">
            Lo que entra al sistema cuando abrís el pack:
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-226">
          {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-227">
              <div className="bg-padel-surface border border-padel-muted rounded-2xl p-6 sm:p-8 h-full relative overflow-hidden group hover:border-padel-lime/40 transition-all" data-id="element-228">
                <div className="absolute top-0 right-0 text-[120px] font-black text-padel-dark/50 leading-none -mt-4 -mr-4 pointer-events-none group-hover:text-padel-lime/5 transition-colors" data-id="element-229">
                  {tomo.num}
                </div>

                <div className="relative z-10" data-id="element-230">
                  <div className="flex items-center gap-3 mb-4" data-id="element-231">
                    <div className="bg-padel-lime/10 text-padel-lime p-2 rounded-lg" data-id="element-232">
                      <BookOpenIcon className="w-6 h-6" data-id="element-233" />
                    </div>
                    <span className="text-padel-lime font-bold tracking-wider text-sm uppercase" data-id="element-234">
                      Tomo {tomo.num}
                    </span>
                  </div>
                  <h4 className="text-2xl font-display font-bold text-white mb-4" data-id="element-235">
                    {tomo.title}
                  </h4>
                  <p className="text-gray-400 leading-relaxed" data-id="element-236">{tomo.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}